document.addEventListener('DOMContentLoaded', () => {
  const btn = document.querySelector('.fbf-menu');
  const nav = document.querySelector('#mobile-nav');
  if (btn && nav) btn.addEventListener('click', () => {
    const open = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', String(!open));
    nav.hidden = open;
  });

  const track = (name, props = {}) => {
    if (!name) return;
    try {
      window.dispatchEvent(new CustomEvent('fbf:event', { detail: { name, props } }));
    } catch (e) {}
  };

  document.querySelectorAll('[data-fbf-track]').forEach(el => {
    el.addEventListener('click', () => track(el.dataset.fbfTrack, {
      page: window.location.pathname,
      step: el.dataset.fbfStep || el.dataset.fbfComplete || ''
    }));
  });

  const progressRoot = document.querySelector('[data-fbf-progress]');
  if (progressRoot) {
    const key = 'fbf_onboarding_stage_v1';
    const cards = [...progressRoot.querySelectorAll('[data-fbf-stage-card]')];
    const label = progressRoot.querySelector('[data-fbf-progress-label]');
    const bar = progressRoot.querySelector('[data-fbf-progress-bar]');
    const done = progressRoot.querySelector('[data-fbf-complete-panel]');
    const stageMap = { registration_started: 0, account_created: 1, funded: 2, pamm_joined: 3, complete: 4 };

    let stage = Math.max(0, Math.min(4, parseInt(localStorage.getItem(key) || '0', 10) || 0));
    const qp = new URLSearchParams(window.location.search).get('fbf_step');
    if (qp && Object.prototype.hasOwnProperty.call(stageMap, qp)) {
      stage = Math.max(stage, stageMap[qp]);
      localStorage.setItem(key, String(stage));
      const qpEvents = {
        registration_started: 'FBF Plexytrade Registration Clicked',
        account_created: 'FBF Plexytrade Account Created',
        funded: 'FBF Plexytrade Account Funded',
        pamm_joined: 'FBF PAMM Joined',
        complete: 'FBF Onboarding Completed'
      };
      track(qpEvents[qp] || 'FBF Onboarding Link Progressed', { onboarding_step: qp, stage, source: 'onboarding email link' });
    }

    const render = () => {
      cards.forEach((card, idx) => {
        const complete = idx < stage;
        card.classList.toggle('is-complete', complete);
        const check = card.querySelector('[data-fbf-check]');
        if (check) check.textContent = complete ? '✓' : String(idx + 1);
      });
      if (label) label.textContent = `${stage} of 4 complete`;
      if (bar) bar.style.width = `${stage * 25}%`;
      if (done) done.hidden = stage < 4;
    };

    progressRoot.querySelectorAll('[data-fbf-complete]').forEach(control => {
      control.addEventListener('click', () => {
        const next = Math.max(0, Math.min(4, parseInt(control.dataset.fbfComplete, 10) || 0));
        stage = Math.max(stage, next);
        localStorage.setItem(key, String(stage));
        render();
      });
    });
    render();
  }

  // Gold Knight lead form: SendGrid-only submission.
  // We intentionally do NOT submit Shopify's native customer form here because
  // Shopify CAPTCHA can fail in Instagram/Facebook in-app browsers with a
  // "Missing CAPTCHA token" error. The Vercel endpoint handles the lead securely,
  // then we redirect directly to the Access page.
  const goldForm = document.querySelector('#GoldKnightLeadForm');
  if (goldForm) {
    const config = goldForm.querySelector('[data-fbf-sendgrid-config]');
    const endpoint = (config && config.dataset.endpoint || '').trim();
    const successUrl = (config && config.dataset.successUrl || '/pages/access').trim();
    const status = goldForm.querySelector('[data-fbf-sendgrid-status]');
    const submitBtn = goldForm.querySelector('button[type="submit"]');

    const setStatus = (message, mode) => {
      if (!status) return;
      status.hidden = false;
      status.textContent = message;
      status.classList.remove('is-working', 'is-error');
      if (mode) status.classList.add(mode);
    };

    goldForm.addEventListener('submit', async (event) => {
      event.preventDefault();

      const emailInput = goldForm.querySelector('input[name="email"]');
      const firstNameInput = goldForm.querySelector('input[name="first_name"]');
      const email = (emailInput && emailInput.value || '').trim();
      const firstName = (firstNameInput && firstNameInput.value || '').trim();

      if (!email || !emailInput.checkValidity()) {
        if (emailInput) emailInput.reportValidity();
        return;
      }

      if (!endpoint) {
        setStatus('Signup is temporarily unavailable. Please try again shortly.', 'is-error');
        return;
      }

      if (submitBtn) submitBtn.disabled = true;
      setStatus('Saving your Gold Knight access request…', 'is-working');

      try {
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 12000);
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          signal: controller.signal,
          body: JSON.stringify({
            email,
            first_name: firstName,
            source: 'FueledByForex Gold Knight homepage form',
            consent: true
          })
        });
        clearTimeout(timeout);

        if (!response.ok) {
          let detail = '';
          try {
            const body = await response.json();
            detail = body && body.error ? body.error : '';
          } catch (e) {}
          throw new Error(detail || `Signup endpoint returned ${response.status}`);
        }

        track('FBF Gold Knight Lead Captured', {
          email_domain: email.split('@')[1] || '',
          email_platform: 'SendGrid'
        });

        setStatus('You’re in — taking you to the next step…', 'is-working');
        window.location.assign(successUrl || '/pages/access');
      } catch (error) {
        console.error('FueledByForex SendGrid signup error:', error);
        setStatus('We couldn’t save your request. Please try again.', 'is-error');
        if (submitBtn) submitBtn.disabled = false;
      }
    });
  }

});
